import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { HOST } from "Constant/Constant";

export const salesUserApi = createApi({
  reducerPath: "salesUserApi",
  baseQuery: fetchBaseQuery({
    baseUrl: HOST,
  }),
  tagTypes: ["SalesUser"],
  endpoints: (builder) => ({
    getSalesUsersList: builder.query({
      query: ({ page, limit, role, isActive, search, sortBy, sortOrder }) => {
        const params = new URLSearchParams();

        if (page) params.append("page", page);
        if (limit) params.append("limit", limit);
        if (search?.trim()) params.append("search", search?.trim());

        if (role) {
          if (Array.isArray(role)) {
            role.forEach((r) => params.append("role", r));
          } else {
            params.append("role", role);
          }
        }

        if (isActive !== undefined && isActive !== "") {
          params.append("isActive", isActive);
        }

        if (sortBy) params.append("sortBy", sortBy);
        if (sortOrder) params.append("sortOrder", sortOrder);

        return {
          url: `/get-sales-users?${params.toString()}`,
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
      },
      providesTags: ["SalesUser"],
    }),

    createSalesUser: builder.mutation({
      query: ({ body }) => ({
        url: "/create-sales-user",
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["SalesUser"],
    }),

    updateSalesUser: builder.mutation({
      query: ({ body }) => ({
        url: "/update-sales-user",
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["SalesUser"],
    }),
    deleteSalesUser: builder.mutation({
      query: (body) => ({
        url: "/delete-sales-user",
        method: "DELETE",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["SalesUser"],
    }),
  }),
});

export const {
  useGetSalesUsersListQuery,
  useCreateSalesUserMutation,
  useUpdateSalesUserMutation,
  useDeleteSalesUserMutation,
} = salesUserApi;
